/* eslint-disable react-hooks/exhaustive-deps */
"use client";

// import {
//   useCallback,
//   useEffect,
//   useRef,
//   type Dispatch,
//   type FormEvent,
//   type SetStateAction
// } from "react";

// import { useClickOutside } from "@/hooks";

export const useFilter = () => {
  // const inputRef = useRef<HTMLInputElement | null>(null);
  // const suggestionContainerRef = useRef<HTMLUListElement | null>(null);
  // useClickOutside(inputRef, () => setSuggestions([]), suggestionContainerRef);
  // const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
  //   e.preventDefault();
  //   if (!value.trim()) return;
  //   if (value) {
  //     const filteredBreed = breeds.filter((breed) =>
  //       breed.name.toLowerCase().startsWith(value.toLowerCase())
  //     );
  //     updateFilters(filteredBreed);
  //   }
  // };
  // const resetSearch = useCallback(() => {
  //   updateFilters(breeds);
  // }, [breeds, updateFilters]);
  // useEffect(() => {
  //   if (!value) {
  //     resetSearch();
  //   }
  // }, [value]);
};
